/* import __COLOCATED_TEMPLATE__ from './company-profile-body.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { showModal } from 'sh-www/utils/modal-controls';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

const SECTIONS = {
  ABOUT: 'About',
  PROJECTS: 'Projects',
  POSTINGS: 'Postings',
};

export default class CompanyProfileBody extends Component {
  @service('commands.assignment-commands') assignmentCommandService;
  @service media;
  @service router;

  @tracked activeNavItem = this.media.isMobile ? SECTIONS.ABOUT : SECTIONS.PROJECTS;
  @tracked activeServiceFilterId = -1;
  @tracked completedProjectsCurrentPage = 1;
  @tracked activeProjectsCurrentPage = 1;
  @tracked postingsCurrentPage = 1;

  get className() {
    return 'company-profile-seller-view__body';
  }

  get activeProjectsCount() {
    return this.args.activeProjectsCount ?? -1;
  }

  get completedProjectsCount() {
    return this.args.completedProjectsCount ?? -1;
  }

  get postings() {
    const postings = this.args.loadPostings.last?.value?.postings.toArray() ?? [];
    return postings.sort((postingA, postingB) => postingB.updatedAt - postingA.updatedAt);
  }

  get activeProjects() {
    return this.args.loadActiveApplications.last?.value?.applications;
  }

  get completedProjects() {
    return this.args.loadCompletedApplications.last?.value?.applications;
  }

  get activeProjectsPagination() {
    return this.args.loadActiveApplications.last?.value?.pagination;
  }

  get completedProjectsPagination() {
    return this.args.loadCompletedApplications.last?.value?.pagination;
  }

  get postingsPagination() {
    return this.args.loadPostings.last?.value?.pagination;
  }

  get showActivePagination() {
    return !this.args.loadActiveApplications.isRunning && this.activeProjectsPagination?.totalPages > 1;
  }

  get showCompletedPagination() {
    return !this.args.loadCompletedApplications.isRunning && this.completedProjectsPagination?.totalPages > 1;
  }

  get showPostingsPagination() {
    return !this.args.loadPostings.isRunning && this.postingsPagination?.totalPages > 1;
  }

  get profileNavItems() {
    const navItems = [];

    if (this.media.isMobile) {
      navItems.push({
        title: SECTIONS.ABOUT,
        isActive: () => this.activeNavItem === SECTIONS.ABOUT,
      });
    }

    const projectsCount = this.activeProjectsCount + this.completedProjectsCount;

    navItems.push({
      title: SECTIONS.PROJECTS,
      isActive: () => this.activeNavItem === SECTIONS.PROJECTS,
      count: projectsCount ?? null,
    });

    navItems.push({
      title: SECTIONS.POSTINGS,
      isActive: () => this.activeNavItem === SECTIONS.POSTINGS,
      count: this.postingsPagination?.total ?? null,
    });

    return navItems;
  }

  @action
  setFavorite(assignment, favorite) {
    return this.assignmentCommandService.setFavorite(assignment, this.args.user.id, favorite);
  }

  @action
  showFeedback(assignment) {
    showModal(this, 'posting-feedback', { assignment });
  }

  @action
  viewPosting(posting) {
    this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__INDEX, posting.id);
  }

  @action
  onProfileNavItemClicked(tab) {
    this.activeNavItem = tab;
  }

  @action
  onServiceFilterClicked(serviceId) {
    this.activeServiceFilterId = serviceId;
    this.completedProjectsCurrentPage = 1;
  }

  @action
  onActiveProjectsPaginationClicked(increment) {
    this.activeProjectsCurrentPage += increment;
  }

  @action
  onCompletedProjectsPaginationClicked(increment) {
    this.completedProjectsCurrentPage += increment;
  }

  @action
  onPostingsPaginationClicked(increment) {
    this.postingsCurrentPage += increment;
  }
}
